import { IFieldProps } from "types/Organisational";

type FormValues = {
  organizational: Record<string, string | null | undefined>;
  shipment: { title: string };
};

export type ShipmentUpdatePayload = {
  shipment: { title: string };
  organizational: Record<string, string | null>;
};

const PROTECTED_FIELD_IDS = new Set(["location", "invoice_location", "shipment_title"]);

export function buildShipmentUpdatePayload(
  values: FormValues,
  organisationFields: IFieldProps[],
  costRecoveryYesValue: string,
): ShipmentUpdatePayload {
  const organizational = organisationFields.reduce<Record<string, string | null>>((payload, field) => {
    const fieldId = field.field_id;
    if (!fieldId || PROTECTED_FIELD_IDS.has(fieldId)) return payload;
    if (
      fieldId.startsWith("custom_cost_recovery_") &&
      values.organizational.cost_recovery_required !== costRecoveryYesValue
    ) {
      return payload;
    }

    const value = values.organizational[fieldId];
    if (value !== undefined) payload[fieldId] = value;
    return payload;
  }, {});

  return {
    shipment: { title: values.shipment.title },
    organizational,
  };
}
